/**
 * /app/predim — list of saved predim designs.
 * Subtype on each card encodes "family:variant" (e.g. "columns:central").
 */

import { Hammer } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function PredimIndexPage() {
  return (
    <DesignsList
      module="predim"
      description="Predimensionamiento preliminar — abre uno guardado o calcula uno nuevo."
      icon={<Hammer size={24} strokeWidth={1.5} />}
    />
  );
}
